import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IAuthState } from '~/models'
import { isJsonString } from '~/utils'
import { RootState } from '../../../app/store'
import { LocalStorageKeys } from '~/constants/localStorageKeys'
const defaultIAuth = {
  userName: null,
  fullName: null,
  roles: [],
  token: null,
  refreshToken : null,
  profilePictureUrl: undefined,
  errorCode : 0
};

const readStorage = (): IAuthState => {
  const storageString = localStorage.getItem(LocalStorageKeys.user)
  if (isJsonString(storageString as string)) {
    return JSON.parse(storageString as string) as IAuthState;
  }
  return defaultIAuth;
}

const initialState: IAuthState = readStorage();

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<IAuthState>) => {
      // Check if profile picture url is a null string ('SgAAAA)
      const profilePicture = action.payload.profilePictureUrl?.includes('SgAAAA')
        ? undefined
        : action.payload.profilePictureUrl
      localStorage.setItem(
        LocalStorageKeys.user,
        JSON.stringify({ ...action.payload, profilePictureUrl: profilePicture })
      )
      state.fullName = action.payload.fullName
      state.roles = action.payload.roles
      state.token = action.payload.token
      state.userName = action.payload.userName
      state.refreshToken = action.payload.refreshToken
      state.profilePictureUrl = profilePicture
      state.errorCode = action.payload.errorCode
    },
    logout: state => {
      localStorage.removeItem(LocalStorageKeys.user)
      state.userName = null
      state.fullName = null
      state.roles = []
      state.token = null
      state.refreshToken = null
      state.profilePictureUrl = undefined
      state.errorCode = 0
    }
  }
})

export const selectAuth = (state: RootState) => state.auth

export const { setUser, logout } = authSlice.actions

export default authSlice.reducer
